import Vue from "vue";
import axios from "axios";
import urlApiJson from "./urlApi.json";
import { join } from "@/utils/formatUtils/url";
// 调用oss中的公用文件
function getResourceJson(path) {
  let url = window.location.origin;
  return axios.get(`${url}/${path}`).then((res) => {
    return res.data;
  });
}

function getApiQuery() {
  let paramsUrl = decodeURIComponent(
    window.location.search.replace(/\&amp%3B/g, "&")
  );
  let reg = new RegExp("(^|&)api=([^&]*)(&|$)");
  let regDevice = new RegExp("(^|&)apiDevice=([^&]*)(&|$)");
  let query = paramsUrl.substr(1).match(reg);
  let queryDevice = paramsUrl.substr(1).match(regDevice);
  // let queryApi = query === null ? 'localhost:38092/' : query[2]
  let queryApi =
    query === null ?
    "backend-console.lhsit.wingedcare.com/services/reporting/api" :
    query[2];
  let queryApiDevice =
    queryDevice === null ?
    "backend-console.lhsit.wingedcare.com/services/devices/api" :
    queryDevice[2];
  return { queryApi: queryApi, queryApiDevice: queryApiDevice };
}
export function env() {
  let response = {
    baseUrl: "http://" + getApiQuery().queryApi,
    baseUrlApi: "http://backend-console.lhsit.wingedcare.com",
    queryApiDevice: "http://" + getApiQuery().queryApiDevice,
  };
  let env = process.env;
  let configRes = null;
  configRes = {
    api_server: response.baseUrl || "http://backend-console.lhsit.wingedcare.com",
    api_server_mobile: response.baseUrl,
    env: env,
    api_server_api: response.baseUrlApi,
    api_server_device: response.queryApiDevice,
  };
  return configRes;
}
let i = 0;
async function api() {
  i++;
  // 这里是构造一个异步方法，等待获取json中的内容
  // 获取项目的api配置，api配置的json文件需上传到下面调用的对应目录
  try {
    let urlHost = window.location.origin;
    let pathname = window.location.pathname;
    // let response = urlHost.indexOf("localhost") > 0 || urlHost.indexOf("808") > 0 ?
    //   urlApiJson : (await getResourceJson("urlconfig/api.json")) || {};
    let res = {
      baseUrl: "http://" + getApiQuery().queryApi,
      baseUrlApi: "http://backend-console.lhsit.wingedcare.com",
    };
    let response =
      urlHost.indexOf("localhost") > 0 || urlHost.indexOf("808") > 0 ? {...urlApiJson, ...res } : {...(await getResourceJson("urlconfig/api.json")), ...res } || {
        ...urlApiJson,
        ...res,
      };
    let config = new Promise((resolve) => {
      let configRes = null;
      let env = process.env;
      for (let key in response) {
        if (key !== "baseUrl") {
          env[key] = response[key];
        }
      }
      configRes = {
        api_server: response.baseUrl || "http://backend-console.lhsit.wingedcare.com",
        api_server_mobile: response.baseUrl,
        env: env,
        api_server_api: response.baseUrlApi,
        api_server_device: response.queryApiDevice,
      };
      // 沒有重定向，可直接用来下载的地址
      Vue.prototype.$privateResourcesDownloadUrl = join(
        configRes.api_server,
        "/private-resource/direct-download?type=PRIVATE_RESOURCE&storagePath="
      );
      let name = parseInt(Math.random() * (999999 + 1), 10);
      Vue.prototype.$getPrivateResourceUrl = function(path, reportDataId, type = '.pdf') {
        return `${Vue.prototype.$privateResourcesDownloadUrl}${path}&reportDataId=${reportDataId}&download=false&fileName=${name}${type}`
      }
      resolve(configRes);
    });
    return config;
  } catch (error) {
    console.log("error++", JSON.stringify(error));
    // 如果请求失败将再次发起请求，如果失败10次以上，将询问用户是否继续重试
    if (i <= 10) {
      api();
    } else {
      Vue.prototype
        .$confirm("请求服务器接口失败，请重试,或退出系统", "重试提示", {
          confirmButtonText: "重试",
          cancelButtonText: "退出",
          type: "warning",
        })
        .then((_) => {
          api();
        })
        .catch((_) => {
          window.opener = null;
          window.close();
          window.location.href = "about:blank";
        });
    }
  }
}

export default api();